export const hasFeature = (feature) => {
  const features = window.beagly?.features || {};
  return feature in features;
};
